export default __webpack_public_path__ + "static/media/reminders.e9f84bf0.png";